import formatDateByLocale from './format-date-by-locale'
import { isEmptyValue } from './object-utils'

export const getProductAttributeValue = (
  node,
  attributesObject,
  isEnhancedViewEnabled,
  defaultValuesFromConfig
) => {
  let nodeName = node?.name
  if (isEnhancedViewEnabled && attributesObject) {
    nodeName = formatValueAsPerAttributeType(attributesObject?.esType, nodeName)
    let temp = ''
    const { valueDisplayMap } = attributesObject
    if (valueDisplayMap) {
      if (valueDisplayMap && valueDisplayMap.hasOwnProperty(nodeName)) {
        temp = valueDisplayMap[nodeName]
      }
    } else {
      // Change this after getting null & empty value placeholders
      temp = isEmptyValue(nodeName) ? defaultValuesFromConfig?.empty : nodeName
    }
    return isEmptyValue(temp) ? '' : temp.toString()?.toLowerCase()
  }
  return isEmptyValue(nodeName) ? '' : nodeName.toString()?.toLowerCase()
}

export const formatValueAsPerAttributeType = (type, value) => {
  switch (type) {
    case 'date':
      return formatDateByLocale(value)
    case 'boolean':
    default:
      return value
  }
}

export const transformValueAsPerAttributeType = (type, value) => {
  switch (type) {
    case 'date':
      return !isNaN(value) && typeof value === 'string' ? +value : value
    case 'integer':
    case 'double':
    case 'long':
      return !isNaN(value) && typeof value !== 'number' ? +value : value
    case 'boolean':
      return deriveBooleanValue(value)
    default:
      return value
  }
}

export const deriveBooleanValue = value => {
  if (typeof value === 'boolean') {
    return value
  }
  if (typeof value === 'string') {
    const temp = value.trim().toLowerCase()
    if (temp === 'true') {
      return true
    }
    if (temp === 'false') {
      return false
    }
  }
  return !!value
}
